import { render, staticRenderFns } from "./Complaints.vue?vue&type=template&id=30bc5460&"
import script from "./Complaints.vue?vue&type=script&lang=js&"
export * from "./Complaints.vue?vue&type=script&lang=js&"
import style0 from "./Complaints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports